import CostBar from 'components/common/CostBar';
import TopBar from 'components/common/TopBar';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import {
  getAddress,
  getBokostnader,
  getDisposableIncome,
  getFellesutgifter,
  getKommunaleAvgifter,
  getMonthlyLivingCost,
} from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';
import { Bokostnader } from 'store/tilstandsrapportEntities/tilstandsrapport/types';
import CostOverview from './CostOverview';
import DisposableIncome from './DisposableIncome';
import EconomyCalculator from './EconomyCalculator';
import LoanCalculator from './LoanCalculator';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  monthlyLivingCost: number;
  address: string;
  bokostnader: Bokostnader;
  fellesutgifter: number;
  kommunaleAvgifter: number;
  disposableIncome: number;
}

const Cost = ({
  monthlyLivingCost,
  tilstandsrapportId,
  address,
  bokostnader,
  fellesutgifter,
  kommunaleAvgifter,
  disposableIncome,
}: Props & StateProps): JSX.Element => {
  return (
    <>
      <TopBar
        title={address}
        backButtonHref={`/overview?tilstandsrapportId=${tilstandsrapportId}`}
        backButtonAs={`/${tilstandsrapportId}`}
      />
      <CostBar monthlyLivingCost={monthlyLivingCost} />
      <CostOverview
        electricity={bokostnader.stroemforbruk}
        fellesutgifter={fellesutgifter}
        insurance={(bokostnader.innboforsikring || 0) + (bokostnader.husforsikring || 0)}
        kommunaleutgifter={kommunaleAvgifter}
        maintenance={bokostnader.vedlikeholdskostnader}
      />
      <LoanCalculator tilstandsrapportId={tilstandsrapportId} />
      <EconomyCalculator tilstandsrapportId={tilstandsrapportId} />
      <DisposableIncome amount={disposableIncome} />
    </>
  );
};

const mapStateToProps = (state: AppState, ownProps: Props): StateProps => ({
  monthlyLivingCost: getMonthlyLivingCost(state, ownProps.tilstandsrapportId),
  address: getAddress(state, ownProps.tilstandsrapportId),
  bokostnader: getBokostnader(state, ownProps.tilstandsrapportId),
  fellesutgifter: getFellesutgifter(state, ownProps.tilstandsrapportId),
  kommunaleAvgifter: getKommunaleAvgifter(state, ownProps.tilstandsrapportId),
  disposableIncome: getDisposableIncome(state, ownProps.tilstandsrapportId),
});

export default connect(
  mapStateToProps,
  null,
)(Cost);
